<div
  class="min-h-available-desktop px-8 max-w-screen-xl mx-auto flex flex-col justify-center items-center gap-4 text-center text-white">
  <h1 class="text-8xl font-bold">Oops!</h1>

  <p class="text-4xl">We can't seem to find the page you're looking for.</p>
</div>